/** @format */

export const FETCH_ORGS_REQUEST = "FETCH_ORGS_REQUEST";
export const FETCH_ORGS_SUCCESS = "FETCH_ORGS_SUCCESS";
export const FETCH_ORGS_FAILURE = "FETCH_ORGS_FAILURE";
